import React from "react";

// Heredamos todos los atributos estándar de un select HTML
interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  value: string;
  label: string;
}

export const Option: React.FC<SelectProps> = ({ value, label, ...props }) => {
  return (
    <option key={value} value={value}>
      {label}
    </option>
  );
};
